<div class="expandable-title-container">
  <i
    class="icon-arrow_forward_ios"
    [ngClass]="{ expanded: expanded }"
    (click)="toggleExpandedState()"
  ></i>
  <div class="title">{{ title }}</div>
</div>
<div>
  <div class="custom-content-container">
    <ng-content select="[right]"></ng-content>
  </div>
  <i class="icon-cross" (click)="onClose()"></i>
</div>
